import MapServiceModel  from '@/models/MapServiceModel';
import doc              from '@widesk-core/decorators/doc';
import { DxfPoi }       from '@models/map/dxfTypes';
import { DxfPlacement } from '@models/map/dxfTypes';

/**
 * Opération custom `POST /imports/{id}/plan/preview` : parse le DXF, gèle la transform,
 * rend le fond (data-URI) et liste les POI. Appel : `setId(importId).save({ method: 'post' })`.
 *
 * Si le DXF est géoréférencé, `isGeoreferenced` vaut true et `suggestedPlacement`
 * porte un descripteur {center, scale, rotation} en EPSG:3857 pour pré-placer le fond.
 */
@doc.path('/imports/{id}/plan/preview')
export default class DxfPreviewModel extends MapServiceModel {
	@doc.string declare svgDataUri: string;
	@doc.number declare width: number;
	@doc.number declare height: number;
	@doc.json declare pois: DxfPoi[];
	@doc.boolean declare isGeoreferenced: boolean;
	@doc.json declare suggestedPlacement: DxfPlacement | null;
}
